module.exports = {["template-constructor-control-text_autosize"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon text_autosize-icon" data-alt="Auto-size" data-alt-pos="left" data-alt-offset="2"></div>\n';
}
return __p;
},}